import { Card } from '@mui/material'
import React from 'react'
import { EditBase as ReactAdminEditBase, TransformData, useTranslate } from 'react-admin'
import { ListActionsWithPermission } from '../ra-rbac'
import { EditBaseProps } from './type'

const defaultListAction = {
  hasCreate: false,
  hasExport: false,
  hasPreview: false,
  hasEdit: false,
  hasShow: true,
  hasList: true,
}

const EditBase: React.FC<EditBaseProps> = ({
  children,
  title,
  listAction = {},
  noCard = false,
  transform: transformProps,
  encType = 'application/json',
  convertToJson = [],
  ...props
}) => {
  const transform = (data): TransformData => {
    let transformaedData = data
    if (transformProps) {
      transformaedData = transformProps(transformaedData)
    }

    return {
      ...transformaedData,
      encType: encType,
      convertToJson: convertToJson,
    }
  }
  const translate = useTranslate()
  return (
    <ReactAdminEditBase mutationMode='pessimistic' {...props} transform={transform}>
      <ListActionsWithPermission
        title={translate(title || '')}
        {...defaultListAction}
        {...listAction}
      />
      {!noCard ? <Card>{children}</Card> : children}
    </ReactAdminEditBase>
  )
}

export default EditBase
